import {useEffect, useRef, useState} from "react";
import {searchApi} from "../../../models/search/search-api";
import {SEARCH_DEBOUNCE_MS, SEARCH_MIN_LENGTH} from "./search-config";

// Asks the server only after the user stopped typing for 300 ms, and drops the answer of a request a newer one replaced,
// so a slow early answer never overwrites the results of what is typed now.
export default function useSearch(params, {enabled = true, delay = SEARCH_DEBOUNCE_MS} = {}) {
    const [state, setState] = useState({loading: false, error: false, data: null, query: ""});
    const controllerRef = useRef(null);
    const key = JSON.stringify(params || {});

    useEffect(() => {
        const query = String(params?.q || "").trim();
        controllerRef.current?.abort();
        if (!enabled || query.length < SEARCH_MIN_LENGTH) {
            setState({loading: false, error: false, data: null, query: ""});
            return undefined;
        }
        setState((current) => ({...current, loading: true, error: false}));
        const controller = new AbortController();
        controllerRef.current = controller;
        const timer = setTimeout(async () => {
            try {
                const data = await searchApi.search({...params, q: query}, {signal: controller.signal});
                if (!controller.signal.aborted) setState({loading: false, error: false, data, query});
            } catch (error) {
                if (!controller.signal.aborted) setState({loading: false, error: true, data: null, query});
            }
        }, delay);
        return () => {
            clearTimeout(timer);
            controller.abort();
        };
        // `key` stands for the params object
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key, enabled, delay]);

    return state;
}
